var image_viewer_rtlignore_default = {
  "fontElementMap": "efizZ",
  "imageContainer": "_318UE",
  "expandContainer": "fBFTP",
  "expandIcon": "ULFOq",
  "pointer": "NPe4f",
  "imageWrapper": "s0hau",
  "imageRatio": "wOWb8",
  "image": "DEe31",
  "imageOverlay": "gSP0t",
  "imagePreload": "vyEfe",
  "imageHighres": "_3-tkL",
  "onlyHighRes": "gs0Cu",
  "image_loading": "yoWAp"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
